export interface IAccountsPayable {
    centerId: number,
    centerAlias: string,
    pending0To45: number,
    pending46To60: number,
    pending61To90: number,
    pending91To120: number,
    pending121To150: number,
    pendingOver150: number,
    totalPending: number,
    payNow: number,
    payAfterDayNumber: number|null,
    centerHasAchOnFile: boolean,
    centerHasLatePaymentsInLastYear: boolean,
    centerHasOutstandingDelinquency: boolean,
    achAccountNumber?: string,
    achRoutingNumber?: string,
    compAchAccountNumber?: string,
    compAchRoutingNumber?: string,
    confirmationAmount?: number,
    confirmationNumber?: string

}

export interface ICompBankInfo {
    vendorName: string,
    bankRoutingNumber: string,
    bankAccountNumber: string
}

export interface ITransactionConfirmation {
    payTo: string,
    payFrom: string,
    status: string,
    sendOn: string,
    deliverBy: string,
    amount: number,
    chaseTransactionNumber: string
}
